<template>
    <SubscriptionTabs tab-key="trials" class="py-12">
        <DataTable
            class="mt-10"
            :headers="headers"
            :items="trials"
            :filters="filters"
        >
            <template #item-trial_type="{ data }">
                <div
                    class="mx-6 inline-flex justify-center rounded-md px-4 py-[3px] text-center text-xs text-gray-500"
                    :class="{
                        'bg-orange-200': data === 'pro',
                        'bg-teal-200': data === 'plugin',
                    }"
                >
                    {{ data }}
                </div>
            </template>

            <template #item-ends_at="{ data }">
                <div class="p-6 text-sm">
                    <div v-if="data" class="text-gray-600">
                        {{ format(new Date(data as string), 'd. L. yyyy') }}
                    </div>
                </div>
            </template>
        </DataTable>
    </SubscriptionTabs>
</template>

<script lang="ts" setup>
import ISubscription from '@/types/Subscription/ISubscription';

import DataTable from '@/components/Atomic/DataTable/DataTable.vue';
import { format } from 'date-fns';
import IPaginationData from '@/components/Atomic/DataTable/types/IPaginationData';
import IDataTableHeader from '@/components/Atomic/DataTable/types/IDataTableHeader';
import { IDataTableFilter } from '@/components/Atomic/DataTable/types/IDataTableFilter';

defineProps<{
    trials: IPaginationData<ISubscription>;
}>();

const headers: IDataTableHeader[] = [
    { text: 'User ID', id: 'id', sortable: true, sortableId: 'id' },
    { text: 'Email', id: 'email' },
    {
        text: 'Type',
        id: 'trial_type',
        sortable: true,
        sortableId: 'trial_type',
    },
    {
        text: 'Trial until',
        id: 'ends_at',
        sortable: true,
        sortableId: 'ends_at',
    },
];

const filters: IDataTableFilter[] = [
    {
        column: 'trial_type',
        label: 'Plan',
        values: [
            {
                label: 'Pro',
                value: 'pro',
            },
            {
                label: 'Plugin',
                value: 'plugin',
            },
        ],
    },
];
</script>

<style></style>
